import requests from "./httpService";

const AdminServices = {
  checkUserLoginDetails: (username) =>
    requests.get(`/login/pin/user/${username}`),
  setupUserPassword: (body) => requests.put(`/users/merchant/password`, body),
  signInUser: (body) => requests.post(`/login/merchant`, body),
  registerUser: (body) => requests.post(`/merchants/onboard/otp`, body),
  getUserPermissions: async (merchant_id, group_id) => {
    const data = await requests.get(
      `/roles/assigned/merchant/${merchant_id}/group/${group_id}`
    );

    if (Number(data?.status) === 0) return data?.user_permissions || [];
    return [];
  },
  verifyOTP: (body) => requests.put(`/merchants/onboard/otp`, body),
  onboardUser: (body) => requests.post(`/merchants/onboard/merchant`, body),
};

export default AdminServices;
